"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReducerState = useReducerState;
var _react = require("react");
var _wizardContext = require("../../contexts/wizard-context");
var _types = require("../../types");
var _utils = require("../../utils");
var _buildSetters = require("./buildSetters");
var _middleware = require("./middleware");
var _reducer = require("./reducer");
function useReducerState({
  currentStep = 1,
  isBackEnabled = false,
  ...rest
}) {
  const [state, dispatch] = (0, _utils.useMiddleware)(_middleware.useBackStep)((0, _react.useReducer)(_reducer.reducer, {
    currentStep,
    isBackEnabled,
    termsAndConditionsAccepted: false,
    ...rest
  }));
  const {
    customerType
  } = (0, _react.useContext)(_wizardContext.wizardContext);
  const {
    current: actions
  } = (0, _react.useRef)((0, _buildSetters.buildSetters)(dispatch));
  (0, _react.useEffect)(() => {
    if (customerType === _types.EWizardCustomerType.OnlyForOtherCustomers) {
      actions.setCustomerType(_types.ECustomerTypeSelection.ExistingCustomer);
    } else {
      actions.setCustomerType(_types.ECustomerTypeSelection.Myself);
    }
  }, [customerType, actions]);
  return {
    ...state,
    ...actions
  };
}
